import React, {Component, Fragment} from 'react'
import PricePlan from "../models/PricePlan";
import {Trans} from "react-i18next";
import {formatCurrency} from "../helpers/utils";

interface Props {
  pricePlan: PricePlan
}

export default class PricePlanComponent extends Component<Props> {
  render() {
    const priceCostTimeUnit = this.props.pricePlan.priceUnitTime
    let priceCost = <>
      <span>Fcfa</span>{formatCurrency(this.props.pricePlan.priceCost)}<span>{priceCostTimeUnit}</span>
      <br/>
      <span>$</span>
      <div className="art-number-mini" style={{display: 'inline'}}>
        {formatCurrency(this.props.pricePlan.priceCostUSD)}
      </div>
      <span>{priceCostTimeUnit}</span>
    </>
    if (!this.props.pricePlan.isFixedCost) {
      priceCost = <><span><Trans>commons.labels.startingFrom</Trans></span><br/>{priceCost}</>
    }

    return (
      <div className="art-a art-price">
        {/* price body */}
        <div className="art-price-body">
          <h5 className="mb-30">{this.props.pricePlan.title}</h5>
          {/* price cost */}
          <div className="art-price-cost">
            <div className="art-number">
              {this.props.pricePlan.priceCost === 0
                ? <><Trans style={{textTransform: 'uppercase'}}>commons.labels.free</Trans><sup>*</sup></>
                : priceCost
              }
            </div>
          </div>

          {/* price cost end */}
          {/* price list */}
          <ul className="art-price-list">
            {
              this.props.pricePlan.pricesList.map(priceList => (
                <li
                  key={priceList.title}
                  className={this.props.pricePlan.isSupportedPriceList(priceList.priceType) ? '' : 'art-empty-item'}
                >
                  {priceList.title}
                </li>
              ))
            }
          </ul>

          {/* price list end */}
          {/* button */}
          <a href="contact.html" className="art-link art-color-link art-w-chevron"><Trans>actions.orderNow</Trans></a>
          {this.props.pricePlan.priceCost === 0 && <div className="art-asterisk"><sup>*</sup><Trans>commons.freePriceNote</Trans></div>}
        </div>
        {/* price body end */}
      </div>
    )
  }
}
